export enum ThemeType {
    LIGHT = "light",
    DARK = "dark",
}
